export default __webpack_public_path__ + "static/media/ic_delete.6215fdd8.svg";